import { useEffect } from 'react';

import { FormElementKind } from '@gearbelt/global';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { AssetSelectFormElement } from '@/components/form/elements/asset-select';
import ArrowLeftIcon from '@/components/icons/arrow-left';
import { useToast } from '@/components/ui/toaster';

export function AWAIssuesPage() {
  const { workspaceId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const toast = useToast();

  useEffect(() => {
    if (location.state?.fromLegacyRepair) {
      location.state.fromLegacyRepair = false;
      toast.warning('To create a repair, first select or create an issue.');
      window.history.replaceState({}, '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- fire once on mount; location.state is only relevant on initial navigation
  }, []);

  return (
    <div className="flex h-[100dvh] w-full flex-col gap-4 bg-white">
      <div className="border-b-grey-3 flex items-center justify-between border-b-2 px-4 py-4">
        <div className="flex items-center gap-1">
          <button onClick={() => navigate(`/${workspaceId}/maintenance`)}>
            <ArrowLeftIcon size={30} />
          </button>
          <div className="line-clamp-1 text-lg font-medium">Select Asset</div>
        </div>
      </div>
      <div className="flex flex-col gap-1 px-4">
        <AssetSelectFormElement
          element={{ id: 'assetId', kind: FormElementKind.AssetSelect, label: 'Asset', required: true, config: { multiple: false } }}
          value=""
          // onChange is required by the component but unused here - we use onChangeFull for navigation with full asset data
          onChange={() => {}}
          onChangeFull={(value) => {
            // Single select mode (multiple: false) returns AssetDTO | null
            if (value && !Array.isArray(value)) {
              navigate(`/${workspaceId}/issues/${value.id}`);
            }
          }}
        />
        <div className="text-secondary-text text-center">Select an asset to view its issue records</div>
      </div>
    </div>
  );
}
